import { useTranslate } from "@tolgee/react";
import CreatorCard from "../commonElements/creatorCard";
import { FormCheck, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaste } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { updatePostKey } from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { UPGRADE_SUBSCRIPTION_URL } from "../../../../config/constants";
import UpgradeRequiredTooltipWrapper from "../../../utils/billing/UpgradeRequiredTooltipWrapper";

export default function MultipostSettings() {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const lomavisCreatorState = useSelector((state: any) => state.lomavisCreator);
  const checkboxes = [
    {
      title: "multipost_use_instagram_default_location_title",
      description: "multipost_use_instagram_default_location_description",
      defaultValue: false,
      key: "multipost_use_instagram_default_location",
      check: true,
    },
    {
      title: "multipost_copied_to_profile_group_for_approval_title",
      description: "multipost_copied_to_profile_group_for_approval_description",
      defaultValue: false,
      key: "multipost_copied_to_profile_group_for_approval",
      check:
        lomavisCreatorState.lomavisCreatorConfig?.features
          ?.publish_to_profile_groups_for_approval,
    },
  ];

  return (
    <CreatorCard>
      {/* Card Title with Icon */}
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-paste me-2 fs-2 text-info"></i>

        <span className="fw-bold">
          {t("lomavisCreator.multipostSettings.title")}
        </span>
      </div>

      {/* Checkbox List */}
      <div className="mt-4">
        {checkboxes.map((checkbox, index) => (
          <div className="mb-2" key={index}>
            <FormCheck
              type="checkbox"
              id={checkbox.title}
              defaultChecked={checkbox.defaultValue}
              className="mb-2 d-flex align-items-start"
            >
              <UpgradeRequiredTooltipWrapper show={!checkbox.check} children={
                <div className={"d-flex flex-row"}>
                  <FormCheck.Input
                      type="checkbox"
                      disabled={!checkbox.check}
                      className="form-check-input form-check-input-sm me-2 mt-1 h-20px w-20px"
                      checked={lomavisCreatorState[checkbox.key]}
                      // forcing aspect ratio to 1 to make it a square. Somehow the last checkbox is not square without this.
                      style={{ aspectRatio: 1 }}
                      onChange={(e) => {
                        if (!checkbox.check) return;
                        dispatch(
                            updatePostKey({
                              key: checkbox.key,
                              value: e.target.checked,
                            })
                        );
                      }}
                  />

                  <FormCheck.Label className="form-check-label text-dark">
                    {/* Title */}
                    {t(`lomavisCreator.multipostSettings.${checkbox.title}`)}
                    {/* Description */}
                    {checkbox.description && (
                        <small className="text-muted d-block mt-1">
                          {t(
                              `lomavisCreator.multipostSettings.${checkbox.description}`
                          )}
                        </small>
                    )}
                  </FormCheck.Label>
                </div>
              } />

            </FormCheck>
          </div>
        ))}
      </div>
    </CreatorCard>
  );
}
